<template>
  <dui-modal
    v-model="computedValue"
    :title="$t('QoalaExternalDashboardProfile.profileSignOut')"
    :is-full-screen="isFullScreen"
    :submit-wording="$helpers.translateKeyContent('FalconDashboard', 'Yes')"
    :cancel-wording="$helpers.translateKeyContent('FalconDashboard', 'No')"
    @submit="logOut"
    @close="$emit('close')"
  >
    <template v-slot:modalContent>
      <v-container class="custom-popup__body">
        <v-icon class="v-icon-alert" size="70" color="var(--bg)">
          {{ mdiAlertCircle }}
        </v-icon>
        <p>
          {{
            $helpers.translateKeyContent(
              "FalconDashboard",
              "Are you sure you want to",
            )
          }}{{ " " }}
          {{
            $t("QoalaExternalDashboardProfile.profileSignOut").toLowerCase()
          }}?
        </p>
      </v-container>
    </template>
  </dui-modal>
</template>

<script>
import { mdiAlertCircle } from "@mdi/js";

export default {
  name: "ModalConfirmationLogoutDesktop",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    isFullScreen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mdiAlertCircle,
      isSubmitting: false,
      dialog: false,
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.custom-popup__body {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  .v-icon-alert {
    color: #ffbe00 !important;
  }
}
.custom-popup__footer {
  padding: 0px;
  text-align: right;
}
</style>
